import { prefixObjectValues as pre } from '../../../utils';

const prefix = 'account-licenses-cds-table';

const pagination = pre(
  {
    total: 'total',
    page: 'page',
    first: 'first',
    last: 'last',
    previous: 'previous',
    next: 'next',
    button: 'button',
  },
  prefix + '-pagination'
);

const columns = pre(
  {
    stateIssuingCode: 'state-code',
    issuingAgency: 'issuing-agency',
    licenseTitle: 'license-title',
    licenseNum: 'license-num',
    expiryDate: 'expiryDate',
    issueDate: 'issueDate',
    activeFlag: 'activeFlag',
    expiredPill: 'expiredPill',
    deleteAction: 'delete-action',
    editAction: 'edit-action',
  },
  prefix + '-column'
);

const table = pre(
  {
    layout: 'layout',
    row: 'row',
    rowActions: 'row-actions',
    stateSort: 'state-code-sort',
    issueSort: 'issue-sort',
    titleSort: 'title-sort',
    expirySort: 'expiry-sort',
    agencySort: 'agency-sort',
    licenseNumSort: 'license-num-sort',
    statusSort: 'status-sort',
    editBtn: 'edit-btn',
    deleteBtn: 'delete-btn',
    emptyState: 'empty-state',
  },
  prefix
);

export default {
  ...table,
  columns,
  pagination,
};
